import { UseGetProductResponse } from "types/queries";

import { trackPdcEvent } from "./track-pdc-event";

export const trackTabSwitchActiveEvent = (
  product: UseGetProductResponse,
  formTrackingId: string,
  step: string | number,
  subStep: string | number
) => {
  trackPdcEvent(product, formTrackingId, "tab_switch_active", step, subStep);
};
